import * as React from "react";

const HeaderAccount: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 21" fill="currentColor">
            <path
                fill="#75B8C8"
                d="M8.75 10.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-8.75A3.754 3.754 0 0 1 12.5 5.5a3.754 3.754 0 0 1-3.75 3.75A3.755 3.755 0 0 1 5 5.5a3.755 3.755 0 0 1 3.75-3.75Zm1.98 10.625H6.77A6.77 6.77 0 0 0 0 19.145c0 .747.606 1.354 1.354 1.354h14.793a1.351 1.351 0 0 0 1.353-1.354 6.77 6.77 0 0 0-6.77-6.77Zm5.415 6.875H1.354a.105.105 0 0 1-.104-.105 5.526 5.526 0 0 1 5.52-5.52h3.957a5.527 5.527 0 0 1 5.523 5.52.105.105 0 0 1-.105.105Z"
            />
        </svg>
    );
};

export default React.memo(HeaderAccount);
